module.exports = __webpack_public_path__ + "static/media/CACAO_01.7b2600d6.png";